import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultUnemployed = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.ARBEITSLOSER }>;
} => ({
    beschaeftigung: {
        arbeitsloser: {
            sonstigesEinkommenMonatlich: null,
        },
        beschaeftigungsart: EMPLOYMENT_TYPES.ARBEITSLOSER,
        steuerklasse: null,
    },
});
export default getDefaultUnemployed;
